import certification from './certification';
import executiveDirectorTeams from './executiveDirectorTeams';
import fibcTeams from './fibcTeams';
import fqv from './fqv';
import gqv from './gqv';
import orderingEntities from './orderingEntities';
import qualifyingPoints from './qualifyingPoints';
import seniorCoachTeams from './seniorCoachTeams';

export default {
  fqv: {...fqv, sortOrder: 1},
  gqv: {...gqv, sortOrder: 2},
  qualifyingPoints: {...qualifyingPoints, sortOrder: 3},
  orderingEntities: {...orderingEntities, sortOrder: 4},
  seniorCoachTeams: {...seniorCoachTeams, sortOrder: 5},
  executiveDirectorTeams: {...executiveDirectorTeams, sortOrder: 6},
  fibcTeams: {...fibcTeams, sortOrder: 7},
  certification: {...certification, sortOrder: 8},
};
